import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { LoadingOverlay } from "../../../../ab-common-legacy/LoadingOverlay";
import GradingSchemesLoader from "./GradingSchemesLoader";
import { Keys } from "../Constants";
import { getApplication } from "../../../../store/Selectors";
import { setField } from "../../../../store/Actions/Actions";
import useGradingSchemesApi from "./useGradingSchemesApi";
import { OTHER_GRADING_SCHEME } from "./consts";
var Question6 = function Question6(_ref) {
  var formValidated = _ref.formValidated,
    dispatch = _ref.dispatch,
    degree = _ref.degree,
    educationCountry = _ref.educationCountry,
    value = _ref.value;
  var allGradingSchemes = useGradingSchemesApi(educationCountry === null || educationCountry === void 0 ? void 0 : educationCountry.code, degree);
  var uiGradingSchemes = useMemo(function () {
    if (allGradingSchemes === null) {
      return null;
    }
    return [].concat(_toConsumableArray(allGradingSchemes.filter(function (scheme) {
      return scheme.active || String(value === null || value === void 0 ? void 0 : value.gradingSchemeId) === String(scheme.id);
    })), [OTHER_GRADING_SCHEME]);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- TODO: fix this
  }, [allGradingSchemes]);
  if (uiGradingSchemes === null) {
    return /*#__PURE__*/React.createElement(LoadingOverlay, null);
  }
  function storeValue(newValue) {
    dispatch(setField({
      key: Keys.Application.mostRecentOverallGrade,
      value: newValue
    }));
  }
  function handleChange(newValue) {
    storeValue(newValue);
  }
  return /*#__PURE__*/React.createElement(GradingSchemesLoader, {
    formValidated: formValidated,
    value: value,
    onChange: handleChange,
    gradingSchemes: uiGradingSchemes
  });
};
var mapStateToProps = function mapStateToProps(state) {
  var applicationData = getApplication(state);
  return {
    educationCountry: applicationData.educationCountry,
    degree: applicationData.degree,
    value: applicationData[Keys.Application.mostRecentOverallGrade]
  };
};
var connector = connect(mapStateToProps);
export default connector(Question6);